import { useEffect, useMemo, useState } from "react";
import type { ProductionWorkspacePlanRow } from "../../../shared/production/workspace-report";
import {recipeKindValid,recipeCostSummary} from "./recipe-cost-presentation";
import { plannedCostProducts } from "./production-recipe-cost-plan";
import { downloadRecipeCostReport } from "./recipe-cost-export";
import { useRecipeCostCalculation } from "./useRecipeCostCalculation";

export function useRecipeCostWorkspace({ planRows }: { planRows: ProductionWorkspacePlanRow[] }) {
  const [query, setQuery] = useState("");
  const [kind, setKind] = useState("0");
  const [detailTab, setDetailTab] = useState<"materials" | "tree">("tree");
  const calculation = useRecipeCostCalculation(kind);
  const plannedProducts = useMemo(() => plannedCostProducts(planRows), [planRows]);
  const filteredProducts = useMemo(() => {
    const term = query.trim().toLocaleUpperCase("tr-TR");
    return term ? plannedProducts.filter(product => `${product.code} ${product.name} ${product.lineNames.join(" ")}`.toLocaleUpperCase("tr-TR").includes(term)) : plannedProducts;
  }, [plannedProducts, query]);
  const selectionValid = !calculation.selected || plannedProducts.some(product => product.code === calculation.selected?.code && product.date === calculation.selected?.date);
  useEffect(() => { if (!selectionValid) calculation.clear(); }, [selectionValid, calculation.clear]);
  const selected = selectionValid ? calculation.selected : null;
  const report = selectionValid ? calculation.report : null;
  const invalid = !recipeKindValid(kind);
  const pending = Boolean(report && (report.asOf !== selected?.date || report.recipeKind !== Number(kind)));
  const {piece, uniqueIssues} = recipeCostSummary(report);
  const download = () => {
    if (!report) return;
    try { downloadRecipeCostReport(report); }
    catch (cause) { calculation.setError(cause instanceof Error ? cause.message : "Hesap dökümü indirilemedi."); }
  };
  return { query, setQuery, selected, kind, setKind, report, loading: selectionValid && calculation.loading, error: selectionValid ? calculation.error : "", detailTab, setDetailTab, plannedProducts, filteredProducts, calculate: calculation.calculate, download, invalid, pending, piece, uniqueIssues };
}
